<template>
    <div>
        <div class="vx-row" v-if="groupData">
            <div class="vx-col w-full xl:w-1/3 lg:w-1/2 md:w-1/2">
                <vx-card v-if="groupData" :title="$t('Data')" class="mb-base" id="page-user-view">
                    <table>
                        <tr>
                            <td class="font-semibold">{{$t("Id")}}</td>
                            <td>{{ groupData.id }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Client")}}</td>
                            <td>{{ $store.getters.companyClients[groupData.client_company_id].name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Date")}}</td>
                            <td>{{ moment(groupData.created).format('DD/MM/YYYY HH:mm') }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("NumberOfTasks")}}</td>
                            <td>{{ groupData.task_num }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("ContractHours")}}</td>
                            <td>{{ groupData.contract_hours }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("TotalTime")}}</td>
                            <td>{{ totalInvoiceTime }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Difference")}}</td>
                            <td>{{ totalInvoiceTime - groupData.contract_hours }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("TaskIds")}}</td>
                            <td>{{ invoiceTaskIds }}</td>
                        </tr>
                    </table>
                    <vs-button class="mt-3 mr-6" style="float: left" color="success" icon-pack="feather" icon="icon-eye" type="border" id="previewButton" @click="generatePreview">{{$t("Preview")}}</vs-button>
                    <vs-button class="mt-3 mr-6" style="float: left" color="success" icon-pack="feather" icon="icon-eye" type="border" id="taskDescriptionExcelButton" @click="generateTaskDescriptionExcel">{{$t("Excel")}}</vs-button>
                    <vs-button style="float: left" v-if="$checkPermission(1102) && groupData.status === 0" class="mt-3" color="danger" icon-pack="feather" icon="icon-trash-2" type="border" @click="removeGroup" >{{$t("RemoveInvoicingGroup")}}</vs-button>
                    <div style="clear: left"></div>

                </vx-card>
            </div>
            <div class="vx-col w-full xl:w-1/3 lg:w-1/2 md:w-1/2">
                <vx-card v-if="files" :title="$t('Files')" class="mb-base">

                    <vs-upload v-if="$checkPermission(1102)" :text="$t('UploadFile')" accept="application/pdf" :automatic="true" limit="1" fileName="file" :action="'/api/v1/invoicing_group/group/' + $route.params.id + '/file'" @on-success="updateFiles" />


                    <vs-table class="mt-4" ref="fileTable" pagination :max-items="4" :data="files">

                        <template slot="thead">
                            <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                            <vs-th sort-key="size">{{$t("Size")}}</vs-th>
                            <vs-th></vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                <vs-td :data="data[index].file_name">
                                    {{ data[index].file_name }}
                                </vs-td>

                                <vs-td :data="data[index].size/1000000">
                                    {{(data[index].size/1000000) + "MB"}}
                                </vs-td>
                                <vs-td>
                                    <vs-button size="small" style="float: left" class="mr-3" color="success" icon-pack="feather" icon="icon-download" type="border" @click="downloadFile(tr.id)" ></vs-button>
                                    <vs-button v-if="$checkPermission(1102)" size="small" style="float: left" color="danger" icon-pack="feather" icon="icon-trash-2" type="border" @click="removeFile(tr.id)" ></vs-button>
                                </vs-td>

                            </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>
                </vx-card>
            </div>
            <div class="vx-col w-full xl:w-1/3 lg:w-1/2 md:w-1/2 mb-6">
                <vx-card :title="$t('Times')">
                    <div slot="no-body">
                        <vue-apex-charts type="donut" height="340" class="mb-12 mt-4" :options="timeTotalsChart" :series="timeChartSeries" />
                    </div>

                    <ul>
                        <li class="flex mb-3 justify-between" :key="index" v-for="(tr, index) in timeTotals">
                            <span class="flex items-center">
                                    <span class="inline-block h-4 w-4 rounded-full mr-2 border-3 border-solid d-theme-dark-bg" v-bind:style="{borderColor: baseColors[index]}"></span>
                                    <span class="font-semibold">{{timeTotals[index].type}}</span>
                            </span>
                            <span>{{timeTotals[index].total_time}}</span>
                        </li>
                    </ul>

                </vx-card>
            </div>
            <div class="vx-col w-full">
                <vx-card v-if="transports" :title="$t('Transport')" class="mb-base">

                    <vs-table class="mt-4" ref="transportsTable" pagination :max-items="50" :data="transports">

                        <template slot="thead">
                            <vs-th sort-key="name">{{$t("Date")}}</vs-th>
                            <vs-th sort-key="name">{{$t("TransportNames")}}</vs-th>
                            <vs-th sort-key="name">{{$t("Kilometers")}}</vs-th>
                            <vs-th sort-key="name">{{$t("Vehicle")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                <vs-td :data="data[index].day">
                                    {{moment(data[index].day).format('DD/MM/YYYY')}}
                                </vs-td>

                                <vs-td :data="data[index].transport_names">
                                    {{ data[index].transport_names }}
                                </vs-td>

                                <vs-td :data="data[index].total_kilometers">
                                    {{ data[index].total_kilometers }}
                                </vs-td>

                                <vs-td :data="data[index].vehicle">
                                    {{ data[index].vehicle }}
                                </vs-td>

                            </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>
                </vx-card>
            </div>
            <div class="vx-col w-full">
                <vx-card v-if="materials" :title="$t('Material')" class="mb-base">

                    <vs-table ref="table" pagination :max-items="10" search :data="materials">

                        <template slot="thead">
                            <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                            <vs-th sort-key="unit">{{$t("Unit")}}</vs-th>
                            <vs-th sort-key="quantity">{{$t("Quantity")}}</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                <vs-td :data="data[index].name">
                                    {{ data[index].name }}
                                </vs-td>

                                <vs-td :data="data[index].unit">
                                    {{data[index].unit }}
                                </vs-td>

                                <vs-td :data="data[index].quantity">
                                    {{ data[index].quantity }}
                                </vs-td>

                            </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>

                </vx-card>
            </div>
            <div class="vx-col w-full">
                <vx-card v-if="tasks" :title="$t('Tasks')" class="mb-base">

                    <vs-table class="mt-4" ref="taskTable" pagination :max-items="100" search :data="tasks">

                        <template slot="thead">
                            <vs-th sort-key="title">{{$t("Name")}}</vs-th>
                            <vs-th sort-key="approval_time">{{$t("ApprovalTime")}}</vs-th>
                            <vs-th></vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <tbody>
                            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                                <vs-td :data="data[index].title">
                                    {{ data[index].title }}
                                </vs-td>

                                <vs-td :data="data[index].approval_time">
                                    {{ moment(data[index].approval_time).format('DD/MM/YYYY HH:mm') }}
                                </vs-td>

                                <vs-td>
                                    <vs-button size="small" style="float: left" class="mr-3" color="success" icon-pack="feather" icon="icon-eye" type="border" @click="openTask(tr.id)" ></vs-button>
                                    <vs-button v-if="$checkPermission(1102) && groupData.status === 0" size="small" style="float: left" color="danger" icon-pack="feather" icon="icon-trash-2" type="border" @click="removeTask(tr.id)" ></vs-button>
                                </vs-td>

                            </vs-tr>
                            </tbody>
                        </template>

                    </vs-table>
                </vx-card>
            </div>
        </div>
    </div>
</template>
<script>

    import VueApexCharts from 'vue-apexcharts'

    export default {
        components: {
            VueApexCharts
        },
        data() {
            return {
                groupData: undefined,

                tasks: undefined,
                files: undefined,
                transports: undefined,
                materials: undefined,

                timeTotals: undefined,
                baseColors: ['#7961F9', '#FF9F43', '#EA5455', '#2980b9', '#4DA0B0', '#1e3c72', '#d6ae7b','#6a3093', '#457fca', '#B24592', '#C02425', '#64b3f4', '#ED8F03', '#1F1C18', '#76b852', '#00C9FF', '#f46b45','#363795', '#e53935', '#fc00ff', '#2c3e50', '#ee9ca7', '#D1913C'],
                timeTotalsChart: {
                    chartOptions: {
                        labels: [],
                        dataLabels: {
                            enabled: false
                        },
                        legend: { show: false },
                        chart: {
                            offsetY: 30,
                            type: 'donut',
                            toolbar: {
                                show: false
                            }
                        },
                        stroke: { width: 0 },
                        colors: this.baseColors,
                    }
                },
            }
        },
        methods: {
            updateInvoicingGroup() {
                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/group/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.groupData = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });

                this.updateTasks();
                this.updateFiles();
                this.updateTimeTotals();
                this.updateTransports();
                this.updateMaterials()

            },
            updateFiles() {
                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/group/' + this.$route.params.id + "/file")
                    .then(function (response) {
                        thisIns.files = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updateTasks() {
                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/group/' + this.$route.params.id + "/task")
                    .then(function (response) {
                        thisIns.tasks = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updateTransports() {
                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/group/' + this.$route.params.id + "/transport")
                    .then(function (response) {
                        thisIns.transports = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updateMaterials() {
                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/group/' + this.$route.params.id + "/materials")
                    .then(function (response) {
                        thisIns.materials = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            updateTimeTotals() {
                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/group/' + this.$route.params.id + "/task_times")
                    .then(function (response) {
                        thisIns.timeTotals = response.data;

                        let labels = [];
                        for(let x = 0; x < thisIns.timeTotals.length; x++){
                            labels.push(thisIns.timeTotals[x].type)
                        }

                        thisIns.timeTotalsChart = {
                            labels: labels,
                            dataLabels: {
                                enabled: false
                            },
                            legend: { show: false },
                            chart: {
                                offsetY: 30,
                                type: 'donut',
                                toolbar: {
                                    show: false
                                }
                            },
                            stroke: { width: 0 },
                            colors: thisIns.baseColors,
                        }

                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            removeGroup() {

                const thisIns = this;
                this.$http.delete('/api/v1/invoicing_group/group/' + this.$route.params.id)
                    .then(function () {
                        thisIns.$router.go(-1)
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        position:'top-right',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            },
            removeFile(id) {
                const thisIns = this;
                this.$http.delete('/api/v1/invoicing_group/group/' + this.$route.params.id + "/file/" + id)
                    .then(function () {
                        thisIns.updateFiles();
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            downloadFile(id){
                if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                    window.location.href = '/api/v1/invoicing_group/group/' + this.$route.params.id + "/file/" + id + "/download";
                }else{
                    window.open('/api/v1/invoicing_group/group/' + this.$route.params.id + "/file/" + id + "/download");
                }

            },
            generatePreview(){
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#previewButton",
                    scale: 0.45
                });
                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/group/' + this.$route.params.id + "/generate/preview")
                    .then(function (response) {
                        thisIns.$vs.loading.close("#previewButton > .con-vs-loading");
                        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                            window.location.href = "/pdf/invoice/" + response.data;
                        }else{
                            window.open("/pdf/invoice/" + response.data, "_blank");
                        }
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close("#previewButton > .con-vs-loading");
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            generateTaskDescriptionExcel(){
                this.$vs.loading({
                    background: "primary",
                    color: "fff",
                    container: "#taskDescriptionExcelButton",
                    scale: 0.45
                });
                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/group/' + this.$route.params.id + "/generate/excel/taskOverview")
                    .then(function (response) {
                        thisIns.$vs.loading.close("#taskDescriptionExcelButton > .con-vs-loading");
                        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
                            window.location.href = '/api/v1/invoicing_group/group/' + thisIns.$route.params.id + "/generate/excel/taskOverview/" + response.data;
                        }else{
                            window.open('/api/v1/invoicing_group/group/' + thisIns.$route.params.id + "/generate/excel/taskOverview/" + response.data, "_blank");
                        }
                    })
                    .catch(function (error) {
                        thisIns.$vs.loading.close("#taskDescriptionExcelButton > .con-vs-loading");
                        thisIns.$vs.notify({
                            title:'Error',
                            position:'top-right',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            openTask(id){
                this.$router.push({ name: 'task', params: { id: "" + id } })
            },
            removeTask(id) {
                const thisIns = this;
                this.$http.delete('/api/v1/invoicing_group/group/' + this.$route.params.id + "/task/" + id)
                    .then(function () {
                        thisIns.updateInvoicingGroup();
                    }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        computed: {
            invoiceTaskIds: function () {

                let ids = "";
                if(this.tasks) {

                    if(this.tasks.length > 0) {
                        ids += this.tasks[0].company_task_id;

                        for (let x = 1; x < this.tasks.length; x++) {
                            ids += ", " + this.tasks[x].company_task_id;
                        }
                    }

                }

                return ids;

            },
            timeChartSeries: function () {

                let series = [];
                if(this.timeTotals){
                    for(let x = 0; x < this.timeTotals.length; x++){
                        series.push(this.timeTotals[x].total_time)
                    }
                }
                return series;

            },
            totalInvoiceTime: function () {

                let time = 0.0;
                if(this.timeTotals){
                    for(let x = 0; x < this.timeTotals.length; x++){
                        time += this.timeTotals[x].total_time
                    }
                }
                return time;

            }
        },
        created() {
            this.updateInvoicingGroup()
        },
    }
</script>
<style lang="scss">
    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 180px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

    }
</style>
